import React, { useEffect, useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import EnvironmentManager from 'Utils/environmentManager';
import BetSlipInfoItem from 'Components/BetSlip/Footer/BetSlipInfoItem';
import inputMinMaxValidator from 'Utils/inputMinMaxValidator';
import {
  BETSLIP_MULTIPLIER_COUNTS_DEFAULTS,
  BETSLIP_COUPON_COUNT_DEFAULTS,
  BETSLIP_MULTI_COUPON_VALUE_MAX_DEFAULTS,
} from 'Store/constants/betSlip';
import { withMixpanel } from 'Utils/mixpanel';

function getCounts (id, isLive) {
  if (id === 'multiplier') return BETSLIP_MULTIPLIER_COUNTS_DEFAULTS.map((item, index) => {
    const cmsValue = EnvironmentManager.getMessageText({
      key: `keyboard_stake_increase_${index + 1}`
    });
    return `+${cmsValue ?? item}`;
  });

  const values = BETSLIP_COUPON_COUNT_DEFAULTS.map((item, index) => {
    const cmsValue = EnvironmentManager.getMessageText({
      key: `multi_coupon_${isLive ? 'live_' : ''}count_${index + 1}`
    });

    return `+${cmsValue ?? item}`;
  });

  const maxValue = EnvironmentManager
    .getMessageText({ key: `max_multi_coupon${isLive ? '_live' : ''}` }) ?? BETSLIP_MULTI_COUPON_VALUE_MAX_DEFAULTS;

  values.push(maxValue);

  return values;
}

let onBlurTimer;

function BetSlipCounts (props) {
  const {
    isLive,
    inputId,
    cost,
    multiplier,
    couponCount,
    system,
    betCount,
    onChange,
    onFinish,
    mixpanel,
  } = props;

  let inputValue, inputLabel;

  if (inputId === 'couponCount') {
    inputValue = couponCount;
    inputLabel = 'Çoklu Kupon';
  } else {
    inputValue = multiplier;
    inputLabel = 'Misli';
  }

  const [value, setValue] = useState(inputValue);

  const handleFinish = () => {
    clearTimeout(onBlurTimer);

    const modifiedValue = inputMinMaxValidator({
      system,
      betCount,
      isLive,

      id: inputId,
      value,
    });

    onChange({
      target: {
        id: inputId,
        value: +modifiedValue.value,
      }
    });

    onFinish();
  };

  // tamam a basıldığında
  const handleCountApply = e => {
    e.preventDefault();

    handleFinish();
  };

  const updateValueState = value => {
    setValue(value);
  };

  const handleCountClick = e => {
    const { dataset } = e.currentTarget;
    const { count } = dataset;
    const newCount = inputRef.current?.value === '' || value === 1 ? (+count) : (+value + +count);

    updateValueState(newCount);
    
    mixpanel.track('Click Stake Increase', { 'Keyboard Stakes': newCount });
  };

  const handleInputClick = useCallback(e => {
    if (e.target.dataset.clicked) {
      return;
    }

    e.target.value = '';
    e.target.setAttribute('value', '');

    e.target.dataset.clicked = true;
  }, []);

  const handleFocus = () => {
    clearTimeout(onBlurTimer);
  };

  const handleChange = e => {
    updateValueState(e.currentTarget.value);
  };

  const handleBlur = () => {
    clearTimeout(onBlurTimer);

    onBlurTimer = setTimeout(() => {
      handleFinish();
    }, 200);
  };

  const inputRef = useRef();

  useEffect(() => {
    // ilk açıldığında clickleniyor
    if (inputRef.current) {
      inputRef.current.click();
    }
  }, []);

  useEffect(() => {
    // her güncellendiğinde focus yapılıyor
    if (inputRef.current) {
      inputRef.current.focus();
    }
  });

  const COUNTS_COLOR_CODE = EnvironmentManager.getMessageText({
    key: 'keyboard_stake_color'
  }) || '#000';
  return (
    <div>
      <div className="betslip__footer__bg" />
      <div className="betslip__footer">
        <div className="betslip__footer__selections single-row">
          <BetSlipInfoItem
            label="Kupon Bedeli"
            className="betslip__footer__selections__info-item__cost"
            value={ `${cost} TL` }
          />

          <BetSlipInfoItem
            id={ inputId }
            label={ inputLabel }
            value={ value }
            inputMaxLength={ 5 }
            type="input"
            onClick={ handleInputClick }
            onChange={ handleChange }
            onFocus={ handleFocus }
            onBlur={ handleBlur }
            ref={ inputRef }
          />
        </div>
      </div>

      <div className="betslip__footer__counts">
        <div>
          { getCounts(inputId, isLive)
            .map(item => (
              <label
                key={ item }
                className="betslip__footer__counts--item"
                htmlFor="couponCount"
                data-count={ +item }
                onClick={ handleCountClick }
                style={ {
                  color: COUNTS_COLOR_CODE,
                  borderColor: COUNTS_COLOR_CODE,
                } }
              >
                { item }
              </label>
            )) }
        </div>
        <a href="#" title="Tamam" className="betslip__footer__counts--button" onClick={ handleCountApply }>Tamam</a>
      </div>
    </div>
  );
}

BetSlipCounts.propTypes = {
  isLive: PropTypes.bool,
  inputId: PropTypes.string,
  cost: PropTypes.number,
  couponCount: PropTypes.number,
  multiplier: PropTypes.number,
  system: PropTypes.any,
  betCount: PropTypes.number,
  onChange: PropTypes.func,
  onFinish: PropTypes.func,
  mixpanel: PropTypes.object,
};

export default React.memo(withMixpanel(BetSlipCounts), (prev, next) => {
  return prev.cost !== next.cost;
});
